import Routes from 'routes/Routes';
import SessionRenewal from 'components/SessionRenewal';

// For Default import Saas.scss
import 'assets/scss/Saas.scss';
// import 'assets/scss/Creative.scss';
// import 'assets/scss/Modern.scss';

const App = () => {
    return <><SessionRenewal /><Routes /></>;
};

export default App;
